<div class="modal-danger" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>{{ message }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger" (click)="bsModalRef.hide()" translate>
        SHARED.CANCEL
      </button>
      <button type="button" class="btn btn-secondary" (click)="backConfirmation()" translate>
        SHARED.DISCARDANDGOBACK
      </button>
    </div>
  </div>
</div>
